import {
  Box,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";

const SelectDevice = ({ devices, selectedDevice, setSelectedDevice }) => {
  const handleChange = (e) => {
    setSelectedDevice(e.target.value);
  };
  return (
    <Box sx={{ flexGrow: 1, px: { xs: 3, md: 4 }, }}>
      {devices === null ? (
        <Box sx={{ textAlign: "center" }}>
          <CircularProgress />
        </Box>
      ) : (
        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4}}
          alignItems="flex-start"
        >
          <Grid item width={{xs: "220px", md: "300px"}}>
            <Box>
              <Typography 
                sx={{
                  px: 1,
                  mt: 2,
                }} variant="h3">Choose your device</Typography>
            </Box>
          </Grid>
          <Grid item xs={2} sm={4} md={8}>
            <Box sx={{ minWidth: 220, maxWidth: 400 }}>
              <FormControl fullWidth variant="outlined" color="info">
                <InputLabel id="select-device">Select your device</InputLabel>
                <Select
                  labelId="select-device"
                  id="select-device"
                  value={selectedDevice}
                  label="Select your device"
                  onChange={handleChange}
                >
                  {devices?.map((device, index) => (
                    <MenuItem key={index} value={device.name}>
                      {device.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default SelectDevice;
